import React from "react";
import toastError from "../../errors/toastError";
import { Button, Divider, Typography } from "@material-ui/core";

const LocationPreview = ({ image, link, description }) => {
  const safeLink = (() => {
    if (typeof link !== "string") return null;
    try {
      const value = new URL(link);
      return value.protocol === "https:" || value.protocol === "http:" ? value.href : null;
    } catch (_) {
      return null;
    }
  })();

  const handleLocation = () => {
    try {
      if (safeLink) window.open(safeLink, "_blank", "noopener,noreferrer");
    } catch (err) {
      toastError(err);
    }
  };

  return (
    <div style={{ minWidth: "250px" }}>
      <div style={{ float: "left" }}>
        <img src={image} alt="loc" onClick={handleLocation} style={{ width: "100px" }} />
      </div>
      {description && (
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <Typography style={{ marginTop: "12px", marginLeft: "15px", marginRight: "15px", float: "left" }} variant="subtitle1" color="primary" gutterBottom>
            <span style={{ whiteSpace: "pre-line" }}>
              {String(description).replace(/\\n/g, "\n")}
            </span>
          </Typography>
        </div>
      )}
      <div style={{ display: "block", content: "", clear: "both" }} />
      <Divider />
      <Button fullWidth color="primary" onClick={handleLocation} disabled={!safeLink}>
        Visualizar
      </Button>
    </div>
  );
};

export default LocationPreview;
